import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import messages from '@containers/ProductDetailContainer/messages';

import { useNewPdDesignEnabled } from '../../hooks/useNewPdDesignEnabled';

import { SectionTitle, Text, Wrapper } from './styled';

interface CompositionProps {
  html: string;
}

export const Composition = ({ html }: CompositionProps) => {
  const newDesign = useNewPdDesignEnabled();

  return (
    <Wrapper>
      <SectionTitle newDesign={newDesign}>
        <FormattedMessage {...messages.fullComposition} />
      </SectionTitle>

      <Text
        newDesign={newDesign}
        dangerouslySetInnerHTML={{
          __html: html,
        }}
      />
    </Wrapper>
  );
};
